import React from 'react';

import '../../../device-preview/modules/_blockquotes.scss';

const Blockquote = (props) => {
  return <blockquote {...props.attributes}>{props.children}</blockquote>;
};

export default Blockquote;
